import { getCurrentLanguageAndInstanceCode } from "services/instances"

export const redirectToNextStep = (navigate) => {
  const [lang, instance] = getCurrentLanguageAndInstanceCode()

  navigate(`../${lang}-${instance}/claims/step-5`, { replace: true })
}
